import { LineItemDataProvider } from '../contexts/LineItemDataContext';
import type { OrderSummaryLineItem } from '../../types/OrderHistory.types';
import { LineItemActionsWrapper } from './LineItemActionsWrapper';
import { HistoryItemUxModWrapper } from '../uxMods/HistoryItemUxModWrapper';
import { LineItemReorderActionStatusProvider } from '../contexts/LineItemReorderActionStatusContext';
import { Box, H4, H5 } from '@vp/swan';
import { ProductDetailsDisplay } from './ProductDetailsDisplay';
import { useOrderSummary } from '../contexts/OrderSummaryContext';
import { useOrderFulfillmentHistory } from '../../hooks/useOrderFulfillmentHistory';

export type HistoryLineItemProps = {
  item: OrderSummaryLineItem;
};

/**
 * Component Wrapper that adds context values to LineItemDataProvider and LineItemActionsDeterminationsWrapper
 */
export const HistoryLineItem = (props: HistoryLineItemProps) => {
  const { item } = props;
  const { isGroupItem, productName } = item;

  const {
    order: { orderNumber },
  } = useOrderSummary();
  const fulfillmentHistory = useOrderFulfillmentHistory();

  return (
    <LineItemDataProvider
      item={item}
      orderNumber={orderNumber}
      fulfillmentHistory={fulfillmentHistory}
    >
      <LineItemActionsWrapper>
        <HistoryItemUxModWrapper>
          <LineItemReorderActionStatusProvider>
            <Box mb={7}>
              {/* This visually hidden product name is intended for those using assistive tech
            because assistive tech expects all info described by a heading to follow it.
            This product name is hidden from visual users to prevent redundancy since we also render
            a visible product name next to the product image */}
              {isGroupItem ? (
                // If this item is part of a group, its group name is already serving as an H4, so we render its product name as an H5
                <H5
                  visuallyHidden
                  id={`product-name-${productName}`}
                  data-testid="visually-hidden-product-name"
                >
                  {productName}
                </H5>
              ) : (
                // If this item is NOT part of a group, its product name will serve as an H4
                <H4
                  visuallyHidden
                  id={`product-name-${productName}`}
                  data-testid="visually-hidden-product-name"
                >
                  {productName}
                </H4>
              )}

              <ProductDetailsDisplay />
            </Box>
          </LineItemReorderActionStatusProvider>
        </HistoryItemUxModWrapper>
      </LineItemActionsWrapper>
    </LineItemDataProvider>
  );
};
